// Global copyright strip shown at the very bottom of every route EXCEPT enterprise dashboard-shell pages.
// Mounted once in App.js — visible on landing pages, admin, auth, etc.
import { useLocation } from "react-router-dom";

const COMPANY = "Humanity First Software Technology Pvt. Ltd";

// Routes that use AppShell / single-viewport service pages — hide the global strip there.
const HIDDEN_ROUTES = ["/dashboard", "/person", "/login", "/signup", "/family/records", "/ai"];
// Exact-match-only hides (child routes like /family/records/* keep the strip).
// The landing-style pages below render CtaFooter which now carries its own copyright line.
const HIDDEN_EXACT = ["/family", "/", "/features", "/pricing", "/demos", "/faq", "/solutions"];

export function CopyrightStrip() {
    const year = new Date().getFullYear();
    const { pathname } = useLocation();
    if (HIDDEN_EXACT.includes(pathname)) return null;
    if (HIDDEN_ROUTES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) return null;
    return (
        <footer
            data-testid="global-copyright-strip"
            className="w-full bg-[#0B1E0D] text-white/85 border-t border-[#1B5E20]/40 px-4 py-3.5 sm:py-4"
        >
            <div className="max-w-7xl mx-auto flex flex-col gap-3">
                <div
                    data-testid="copyright-text"
                    className="text-center text-[11.5px] sm:text-[12px] text-white/80 leading-relaxed"
                >
                    <p className="m-0">
                        © {year} <span className="font-semibold text-white">{COMPANY}</span> — All rights
                        reserved · Designed &amp; developed in India
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default CopyrightStrip;
